/*
  We use a colon (rather than a full-stop as a time separator).
  See: https://guides.service.gov.au/content-guide/numbers-measurements/#hours-and-minutes
*/
const auOperatingHoursPL = "Monday to Friday: 9am - 5pm\r\nWeekends: Closed";
const nzOperatingHoursPL =
  "Monday to Friday: 8:30am - 6:30pm\r\nWeekends: Closed";
const auOperatingHoursCC = "Monday to Friday: 9am - 5pm\r\nWeekends: Closed";
const nzOperatingHoursCC =
  "Monday to Friday: 10:30am - 6:30pm\r\nWeekends: Closed";

/*
  We store the contact info in the `contactsMap` because some of it
  is reused in the `productsData` below.
*/
const contactsMap = {
  // Personal Loans
  "Latitude Personal Loan": {
    region: "AU",
    phoneAu: "1300 973 422",
    phoneOs: "+61 283 781 564",
    hrs: auOperatingHoursPL,
  },
  "NZ Personal Loan": {
    region: "NZ",
    complaints: "https://www.gemfinance.co.nz/complaints/",
    phoneNz: "0800 422 898",
    phoneOs: "+64 800 422 898",
    hrs: nzOperatingHoursPL,
  },
  // Credit Cards
  "Latitude Gem Visa": {
    region: "AU",
    url: "https://online.gemvisa.com.au/access/cards/GEMAU/contactus.html",
    phoneAu: "1300 630 977",
    phoneOs: "+61 287 478 167",
    lostAu: "1800 005 809",
    lostOs: "+61 287 478 167",
    hrs: auOperatingHoursCC,
    fax: "1300 369 905",
    mail: "Latitude Gem Visa\r\nPO Box 1007\r\nMelbourne VIC, 3001",
    facebook: "https://www.facebook.com/latitudefinancialservices/",
    mastercardInternationalTitle: "Visa Global Customer Assistance Services",
    mastercardInternationalPhone: "+1 303 967 1090",
    mastercardInternationalLink:
      "https://www.visa.com.au/dam/VCOM/regional/ap/documents/gcas-ap-en.pdf",
  },
  "GO Mastercard": {
    region: "AU",
    url: "https://gomastercard-online.gomastercard.com.au/access/cards/GOMasterCard/contactus.html",
    phoneAu: "1300 462 273",
    phoneOs: "+61 287 478 170",
    lostAu: "1800 005 809",
    lostOs: "+61 287 478 170",
    hrs: auOperatingHoursCC,
    fax: "1300 369 905",
    mail: "GO Mastercard Customer Service\r\nGPO Box 1300\r\nMelbourne VIC 3001",
    facebook: "https://www.facebook.com/latitudefinancialservices/",
    mastercardInternationalTitle: "Mastercard Global Assist",
    mastercardInternationalPhone: "+1 636 722 7111",
    mastercardInternationalLink:
      "https://www.mastercard.com.au/en-au/contact-us.html",
  },
  "GO Platinum Mastercard": {
    region: "AU",
    url: "https://gomastercard-online.gomastercard.com.au/access/cards/GOMasterCard/contactus.html",
    phoneAu: "1300 462 273",
    phoneOs: "+61 287 478 170",
    lostAu: "1800 005 809",
    lostOs: "+61 287 478 170",
    hrs: auOperatingHoursCC,
    fax: "1300 369 905",
    mail: "GO Mastercard Customer Service\r\nGPO Box 1300\r\nMelbourne VIC 3001",
    facebook: "https://www.facebook.com/latitudefinancialservices/",
    mastercardInternationalTitle: "Mastercard Global Assist",
    mastercardInternationalPhone: "+1 636 722 7111",
    mastercardInternationalLink:
      "https://www.mastercard.com.au/en-au/contact-us.html",
  },
  "Buyer's Edge": {
    region: "AU",
    phoneAu: "1300 361 152",
    phoneOs: "+61 1300 361 152",
    lostAu: "1800 005 809",
    lostOs: "+61 1800 005 809",
    hrs: auOperatingHoursCC,
    fax: "1300 369 905",
    mail: "Buyer’s Edge\r\nPO Box 1007\r\nMelbourne VIC, 3001",
  },
  CreditLine: {
    region: "AU",
    phoneAu: "1300 131 024",
    phoneOs: "+61 287 478 151",
    lostAu: "1800 005 809",
    lostOs: "+61 287 478 151",
    hrs: auOperatingHoursCC,
    fax: "1300 369 905",
    mail: "CreditLine\r\nGPO Box 1007\r\nMelbourne VIC, 3001",
    facebook: "https://www.facebook.com/latitudefinancialservices/",
  },
  "CreditLine - Apple Financial Services": {
    region: "AU",
    phoneAu: "1300 131 024",
    phoneOs: "+61 287 478 151",
    lostAu: "1800 005 809",
    lostOs: "+61 287 478 151",
    hrs: auOperatingHoursCC,
    fax: "1300 369 905",
    mail: "CreditLine\r\nGPO Box 1007\r\nMelbourne VIC, 3001",
    facebook: "https://www.facebook.com/latitudefinancialservices/",
  },
  "Latitude 28 Degrees Global Platinum Mastercard": {
    region: "AU",
    phoneAu: "1300 552 079",
    phoneOs: "+61 287 478 178",
    lostAu: "1800 005 809",
    lostOs: "+61 287 478 178",
    hrs: auOperatingHoursCC,
    fax: "1300 369 905",
    mail: "Latitude 28 Degrees Global Customer Service\r\nGPO Box 1818\r\nMelbourne VIC, 3001",
    facebook:
      "Redirects to product FB page and Redirects to dedicated Skype account (similar to Go Mastercard)",
    mastercardInternationalTitle: "Mastercard Global Assist",
    mastercardInternationalPhone: "+1 636 722 7111",
    mastercardInternationalLink:
      "https://www.mastercard.com.au/en-au/contact-us.html",
  },
  "Latitude Infinity Rewards Visa": {
    region: "AU",
    url: "https://latitudeinfinity-online.latitudefinancial.com.au/access/cards/LatitudeInfinity/contactus.html",
    phoneAu: "1300 783 820",
    phoneOs: "+61 287 478 149",
    lostAu: "1800 005 809",
    lostOs: "+61 287 478 178",
    hrs: auOperatingHoursCC,
    fax: "1300 369 905",
    mail: "Latitude Infinity Customer Service\r\nGPO Box 940\r\nMelbourne VIC, 3001",
    mastercardInternationalTitle: "Visa Global Customer Assistance Services",
    mastercardInternationalPhone: "+1 303 967 1090",
    mastercardInternationalLink:
      "https://www.visa.com.au/dam/VCOM/regional/ap/documents/gcas-ap-en.pdf",
  },
  "Latitude Infinity Rewards Platinum Visa": {
    region: "AU",
    url: "https://latitudeinfinity-online.latitudefinancial.com.au/access/cards/LatitudeInfinity/contactus.html",
    phoneAu: "1300 783 820",
    phoneOs: "+61 287 478 149",
    lostAu: "1800 005 809",
    lostOs: "+61 287 478 178",
    hrs: auOperatingHoursCC,
    fax: "1300 369 905",
    mail: "Latitude Infinity Customer Service\r\nGPO Box 940\r\nMelbourne VIC, 3001",
    mastercardInternationalTitle: "Visa Global Customer Assistance Services",
    mastercardInternationalPhone: "+1 303 967 1090",
    mastercardInternationalLink:
      "https://www.visa.com.au/dam/VCOM/regional/ap/documents/gcas-ap-en.pdf",
  },
  "Latitude Mastercard": {
    region: "AU",
    phoneAu: "1300 882 289",
    phoneOs: "+61 287 478 173",
    lostAu: "1800 005 809",
    lostOs: "+61 287 478 173",
    hrs: auOperatingHoursCC,
    fax: "1300 369 905",
    mail: "Latitude MasterCard\r\nGPO Box 3063\r\nMelbourne VIC, 3001",
    mastercardInternationalTitle: "Mastercard Global Assist",
    mastercardInternationalPhone: "+1 636 722 7111",
    mastercardInternationalLink:
      "https://www.mastercard.com.au/en-au/contact-us.html",
  },
  "Latitude Eco Mastercard": {
    region: "AU",
    url: "https://eco-online.latitudefinancial.com.au/access/cards/EcoMasterCard/contactus.html",
    phoneAu: "1300 734 543",
    phoneOs: "+61 287 478 158",
    lostAu: "1800 005 809",
    lostOs: "+61 287 478 158",
    hrs: auOperatingHoursCC,
    fax: "1300 369 905",
    mail: "Latitude Eco MasterCard\r\nGPO Box 140\r\nMelbourne VIC, 3001",
    mastercardInternationalTitle: "Mastercard Global Assist",
    mastercardInternationalPhone: "+1 636 722 7111",
    mastercardInternationalLink:
      "https://www.mastercard.com.au/en-au/contact-us.html",
  },
  "Latitude Low Rate Mastercard": {
    region: "AU",
    url: "https://lowrate-online.latitudefinancial.com.au/access/cards/LatitudeLowRateMasterCard/contactus.html",
    phoneAu: "1300 721 394",
    phoneOs: "+61 287 478 179",
    lostAu: "1800 005 809",
    lostOs: "+61 287 478 179",
    hrs: auOperatingHoursCC,
    fax: "1300 369 905",
    mail: "Latitude Low Rate MasterCard\r\nGPO Box 140\r\nMelbourne VIC, 3001",
    mastercardInternationalTitle: "Mastercard Global Assist",
    mastercardInternationalPhone: "+1 636 722 7111",
    mastercardInternationalLink:
      "https://www.mastercard.com.au/en-au/contact-us.html",
  },
  CareCredit: {
    region: "AU",
    phoneAu: "1300 662 273",
    phoneOs: "+61 1300 662 273",
    lostAu: "1800 005 809",
    lostOs: "+61 1800 005 809",
    hrs: auOperatingHoursCC,
    fax: "1300 369 905",
    mail: "CreditLine\r\nGPO Box 1007\r\nMelbourne VIC, 3001",
    facebook: "https://www.facebook.com/latitudefinancialservices/",
  },
  "Gem Visa": {
    region: "NZ",
    complaints: "https://www.gemfinance.co.nz/complaints/",
    phoneNz: "0800 500 505",
    phoneOs: "+64 800 500 505",
    lostNz: "0800 500 505",
    lostOs: "+64 800 500 505",
    hrs: nzOperatingHoursCC,
    fax: "0800 655 633",
    mail: "Gem\r\nPO Box 4058\r\nShortland Street\r\nAuckland 1140",
    mastercardInternationalTitle: "Visa Global Customer Assistance Services",
    mastercardInternationalPhone: "+1 303 967 1090",
    mastercardInternationalLink:
      "https://www.visa.com.au/dam/VCOM/regional/ap/documents/gcas-ap-en.pdf",
  },
  "Gem CreditLine": {
    region: "NZ",
    complaints: "https://www.gemfinance.co.nz/complaints/",
    phoneNz: "0800 500 505",
    phoneOs: "+64 800 500 505",
    lostNz: "0800 500 505",
    lostOs: "+64 800 500 505",
    hrs: nzOperatingHoursCC,
    fax: "0800 655 633",
    mail: "Gem\r\nPO Box 4058\r\nShortland Street\r\nAuckland 1140",
  },
  "Gem Essential": {
    region: "NZ",
    complaints: "https://www.gemfinance.co.nz/complaints/",
    url: "https://online.onecardvisa.co.nz/access/cards/ONECARDNZ/contactus.html",
    phoneNz: "0800 500 505",
    phoneOs: "+64 800 500 505",
    lostNz: "0800 500 505",
    lostOs: "+64 800 500 505",
    hrs: nzOperatingHoursCC,
    fax: "0800 655 633",
    mail: "Gem Essential\r\nPO Box 4058\r\nShortland Street\r\nAuckland 1140",
    mastercardInternationalTitle: "Visa Global Customer Assistance Services",
    mastercardInternationalPhone: "+1 303 967 1090",
    mastercardInternationalLink:
      "https://www.visa.com.au/dam/VCOM/regional/ap/documents/gcas-ap-en.pdf",
  },
};

/* cSpell:disable */
const productsData = [
  {
    name: "Latitude 28 Degrees Global Platinum Mastercard",
    product_id: "12435c5f-eec3-4536-bcca-bd6f5f2ggdd0",
    card_image: "Card-Latitude28DegreesGlobalPlatinumMastercard.png",
    osc_url: "https://28degrees-online.latitudefinancial.com.au/access/login",
    contact: contactsMap["Latitude 28 Degrees Global Platinum Mastercard"],
  },
  {
    name: "Better Start Personal Loan",
    product_id: "1813a98b-2236-4eab-b65b-357394864a11",
    url: "https://www.gemfinance.co.nz/loans/personal-loans/",
    isBetterStart: true,
    contact: contactsMap["NZ Personal Loan"],
  },
  {
    name: "Better Start Personal Loan",
    product_id: "5f8b1910-c8f0-4b04-b1ce-cdae49445678",
    isBetterStart: true,
    url: "https://www.latitudefinancial.com.au/personal-loan/",
    contact: contactsMap["Latitude Personal Loan"],
  },
  {
    name: "Better Start Personal Loan",
    product_id: "bf0570a7-758c-4c2b-b90b-1ec7c1426eae",
    isBetterStart: true,
    url: "https://www.latitudefinancial.com.au/personal-loan/",
    contact: contactsMap["Latitude Personal Loan"],
  },
  {
    name: "Better Start Personal Loan",
    product_id: "6cc25794-8779-427d-8cdd-cb4ce27c2fc2",
    isBetterStart: true,
    url: "https://www.gemfinance.co.nz/loans/personal-loans/",
    contact: contactsMap["NZ Personal Loan"],
  },
  {
    name: "Buyer's Edge",
    product_id: "12435c5f-eec3-4536-bcca-bd6f5f2ggd15",
    card_image: "Card-BuyersEdge.png",
    osc_url: "https://online.buyersedge.com.au/access/login",
    contact: contactsMap["Buyer's Edge"],
  },
  {
    name: "CareCredit",
    product_id: "12435c5f-eec3-4536-bcca-bd6f5f2ggdd2",
    card_image: "Card-CareCredit.png",
    osc_url: "https://online.interestfree.com.au/access/login",
    contact: contactsMap.CareCredit,
  },
  {
    name: "CreditLine",
    product_id: "12435c5f-eec3-4536-bcca-bd6f5f2ggdd8",
    card_image: "Card-CreditLine.png",
    osc_url: "https://online.interestfree.com.au/access/login",
    contact: contactsMap.CreditLine,
  },
  {
    name: "CreditLine - Apple Financial Services",
    product_id: "12435c5f-eec3-4536-bcca-bd6f5f2ggdd3",
    card_image: "Card-CreditLineAppleFinancialServices.png",
    osc_url: "https://online.interestfree.com.au/access/login",
    contact: contactsMap["CreditLine - Apple Financial Services"],
  },
  {
    name: "Gem CreditLine",
    product_id: "12435c5f-eec3-4536-bcca-bd6f5f2ggdd9",
    card_image: "Card-GemCreditLine.png",
    osc_url: "https://online.gemcreditline.co.nz/",
    contact: contactsMap["Gem CreditLine"],
  },
  {
    name: "Latitude Gem Visa",
    product_id: "12435c5f-eec3-4536-bcca-bd6f5f2ggd10",
    card_image: "Card-LatitudeGemVisa.png",
    osc_url: "https://online.gemvisa.com.au/access/login",
    contact: contactsMap["Latitude Gem Visa"],
  },
  {
    name: "Gem Visa",
    product_id: "12435c5f-eec3-4536-bcca-bd6f5f2ggd13",
    card_image: "Card-GemVisa.png",
    osc_url: "https://online.gemvisa.co.nz/",
    contact: contactsMap["Gem Visa"],
  },
  {
    name: "GO Mastercard",
    product_id: "12435c5f-eec3-4536-bcca-bd6f5f2ggdd5",
    card_image: "Card-GoMastercard.png",
    osc_url: "https://gomastercard-online.gomastercard.com.au/access/login",
    contact: contactsMap["GO Mastercard"],
  },
  {
    name: "GO Platinum Mastercard",
    product_id: "12435c5f-eec3-4536-bcca-bd6f5f2ggdd7",
    card_image: "Card-GoPlatinumMastercard.png",
    osc_url: "https://gomastercard-online.gomastercard.com.au/access/login",
    contact: contactsMap["GO Platinum Mastercard"],
  },
  {
    name: "Latitude Eco Mastercard",
    product_id: "12435c5f-eec3-4536-bcca-bd6f5f2ggdd6",
    card_image: "Card-LatitudeEcoMastercard.png",
    osc_url: "https://eco-online.latitudefinancial.com.au/access/login",
    contact: contactsMap["Latitude Eco Mastercard"],
  },
  {
    name: "Latitude Low Rate Mastercard",
    product_id: "12435c5f-eec3-4536-bcca-bd6f5f2ggdd4",
    card_image: "Card-LatitudeLowRateMastercard.png",
    osc_url: "https://lowrate-online.latitudefinancial.com.au/access/login",
    contact: contactsMap["Latitude Low Rate Mastercard"],
  },
  {
    name: "Latitude Mastercard",
    product_id: "12435c5f-eec3-4536-bcca-bd6f5f2ggdd1",
    card_image: "Card-Latitude.png",
    osc_url:
      "https://latitudemastercard-online.latitudefinancial.com.au/access/login",
    contact: contactsMap["Latitude Mastercard"],
  },
  {
    name: "Latitude Infinity Rewards Platinum Visa",
    product_id: "12435c5f-eec3-4536-bcca-bd6f5f2ggd12",
    card_image: "Card-LatitudeInfinityRewardsPlatinumVisa.png",
    osc_url:
      "https://latitudeinfinity-online.latitudefinancial.com.au/access/login",
    contact: contactsMap["Latitude Infinity Rewards Platinum Visa"],
  },
  {
    name: "Latitude Infinity Rewards Visa",
    product_id: "12435c5f-eec3-4536-bcca-bd6f5f2ggd11",
    card_image: "Card-LatitudeInfinityRewardsVisa.png",
    osc_url:
      "https://latitudeinfinity-online.latitudefinancial.com.au/access/login",
    contact: contactsMap["Latitude Infinity Rewards Visa"],
  },
  {
    name: "Gem Essential",
    product_id: "12435c5f-eec3-4536-bcca-bd6f5f2ggd14",
    card_image: "Card-GemEssential.png",
    osc_url: "https://online.onecardvisa.co.nz/",
    contact: contactsMap["Gem Essential"],
  },
  {
    name: "Latitude Personal Loan",
    product_id: "21e494ca-bbbe-4732-a881-72ca51797b08",
    url: "https://www.latitudefinancial.com.au/personal-loan/",
    contact: contactsMap["Latitude Personal Loan"],
  },
  {
    name: "Gem Personal Loan",
    product_id: "f85badd0-4de4-48ce-b6f9-e5be72ab9a06",
    url: "https://www.gemfinance.co.nz/loans/personal-loans/",
    contact: contactsMap["NZ Personal Loan"],
  },
  {
    name: "Latitude Personal Loan",
    product_id: "21e494ca-bbbe-4732-a881-72ca51797b04",
    url: "https://www.latitudefinancial.com.au/personal-loan/",
    contact: contactsMap["Latitude Personal Loan"],
  },
  {
    name: "Latitude Personal Loan",
    product_id: "21e494ca-bbbe-4732-a881-72ca51797b11",
    url: "https://www.latitudefinancial.com.au/personal-loan/",
    contact: contactsMap["Latitude Personal Loan"],
  },
  {
    name: "Gem Personal Loan",
    product_id: "f85badd0-4de4-48ce-b6f9-e5be72ab9a05",
    url: "https://www.gemfinance.co.nz/loans/personal-loans/",
    contact: contactsMap["NZ Personal Loan"],
  },
  {
    name: "Gem Personal Loan",
    product_id: "f85badd0-4de4-48ce-b6f9-e5be72ab9a07",
    url: "https://www.gemfinance.co.nz/loans/personal-loans/",
    contact: contactsMap["NZ Personal Loan"],
  },
  {
    name: "Latitude Personal Loan",
    product_id: "21e494ca-bbbe-4732-a881-72ca51797b06",
    url: "https://www.latitudefinancial.com.au/personal-loan/",
    contact: contactsMap["Latitude Personal Loan"],
  },
  {
    name: "Latitude Personal Loan",
    product_id: "21e494ca-bbbe-4732-a881-72ca51797b09",
    url: "https://www.latitudefinancial.com.au/personal-loan/",
    contact: contactsMap["Latitude Personal Loan"],
  },
  {
    name: "Gem Personal Loan",
    product_id: "f85badd0-4de4-48ce-b6f9-e5be72ab9a02",
    url: "https://www.gemfinance.co.nz/loans/personal-loans/",
    contact: contactsMap["NZ Personal Loan"],
  },
  {
    name: "Latitude Personal Loan",
    product_id: "21e494ca-bbbe-4732-a881-72ca51797b03",
    url: "https://www.latitudefinancial.com.au/personal-loan/",
    contact: contactsMap["Latitude Personal Loan"],
  },
  {
    name: "Latitude Personal Loan",
    product_id: "21e494ca-bbbe-4732-a881-72ca51797b01",
    url: "https://www.latitudefinancial.com.au/personal-loan/",
    contact: contactsMap["Latitude Personal Loan"],
  },
  {
    name: "Gem Personal Loan",
    product_id: "f85badd0-4de4-48ce-b6f9-e5be72ab9a04",
    url: "https://www.gemfinance.co.nz/loans/personal-loans/",
    contact: contactsMap["NZ Personal Loan"],
  },
  {
    name: "Latitude Personal Loan",
    product_id: "21e494ca-bbbe-4732-a881-72ca51797b14",
    url: "https://www.latitudefinancial.com.au/personal-loan/",
    contact: contactsMap["Latitude Personal Loan"],
  },
  {
    name: "Latitude Personal Loan",
    product_id: "21e494ca-bbbe-4732-a881-72ca51797b13",
    url: "https://www.latitudefinancial.com.au/personal-loan/",
    contact: contactsMap["Latitude Personal Loan"],
  },
  {
    name: "Gem Personal Loan",
    product_id: "f85badd0-4de4-48ce-b6f9-e5be72ab9a13",
    url: "https://www.gemfinance.co.nz/loans/personal-loans/",
    contact: contactsMap["NZ Personal Loan"],
  },
  {
    name: "Latitude Personal Loan",
    product_id: "21e494ca-bbbe-4732-a881-72ca51797b05",
    url: "https://www.latitudefinancial.com.au/personal-loan/",
    contact: contactsMap["Latitude Personal Loan"],
  },
  {
    name: "Gem Personal Loan",
    product_id: "f85badd0-4de4-48ce-b6f9-e5be72ab9a08",
    url: "https://www.gemfinance.co.nz/loans/personal-loans/",
    contact: contactsMap["NZ Personal Loan"],
  },
  {
    name: "Gem Personal Loan",
    product_id: "f85badd0-4de4-48ce-b6f9-e5be72ab9a09",
    url: "https://www.gemfinance.co.nz/loans/personal-loans/",
    contact: contactsMap["NZ Personal Loan"],
  },
  {
    name: "Latitude Personal Loan",
    product_id: "21e494ca-bbbe-4732-a881-72ca51797b12",
    url: "https://www.latitudefinancial.com.au/personal-loan/",
    contact: contactsMap["Latitude Personal Loan"],
  },
  {
    name: "Gem Personal Loan",
    product_id: "f85badd0-4de4-48ce-b6f9-e5be72ab9a10",
    url: "https://www.gemfinance.co.nz/loans/personal-loans/",
    contact: contactsMap["NZ Personal Loan"],
  },
  {
    name: "Gem Personal Loan",
    product_id: "f85badd0-4de4-48ce-b6f9-e5be72ab9a03",
    url: "https://www.gemfinance.co.nz/loans/personal-loans/",
    contact: contactsMap["NZ Personal Loan"],
  },
  {
    name: "Latitude Personal Loan",
    product_id: "21e494ca-bbbe-4732-a881-72ca51797b02",
    url: "https://www.latitudefinancial.com.au/personal-loan/",
    contact: contactsMap["Latitude Personal Loan"],
  },
  {
    name: "Latitude Personal Loan",
    product_id: "21e494ca-bbbe-4732-a881-72ca51797b10",
    url: "https://www.latitudefinancial.com.au/personal-loan/",
    contact: contactsMap["Latitude Personal Loan"],
  },
  {
    name: "Latitude Personal Loan",
    product_id: "21e494ca-bbbe-4732-a881-72ca51797b07",
    url: "https://www.latitudefinancial.com.au/personal-loan/",
    contact: contactsMap["Latitude Personal Loan"],
  },
  {
    name: "Gem Personal Loan",
    product_id: "f85badd0-4de4-48ce-b6f9-e5be72ab9a01",
    url: "https://www.gemfinance.co.nz/loans/personal-loans/",
    contact: contactsMap["NZ Personal Loan"],
  },
];

export { productsData };
